import { websocketTokenSchema } from '../schema/WebsocketToken.ts';
import { validateData } from '../utils/utils.ts';
import { api } from './client.ts';
import { getWebsocketTokenUrl } from './constants.ts';

export async function getWebsocketToken(signal?: AbortSignal) {
  const { data } = await api.get(getWebsocketTokenUrl, { signal });
  return validateData(websocketTokenSchema, data, 'Websocket Token');
}
